import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BetBuilderProvider } from '@cds/betting-offer/add-ons';

import { BaseBetslipGroupPick } from '../../../core/picks/betslip-group-pick';
import { BetBuilderSelectionModel } from './betbuilder-selection.model';

@Component({
    selector: 'bs-betbuilder-pick-ui',
    templateUrl: './betbuilder-pick-ui.component.html',
    styleUrls: ['./betbuilder-pick-ui.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetbuilderPickUIComponent {
    @Input() pick: BaseBetslipGroupPick;
    @Input() isCombo = false;
    @Input() isEpcotEnabled = false;
    @Input() headerTitle = '';
    @Input() date = '';
    @Input() selections: BetBuilderSelectionModel[];
    @Input() isRemoveButtonVisible: boolean;
    @Input() hasWarning = false;
    @Input() provider: BetBuilderProvider = BetBuilderProvider.Default;
    @Output() removeSelection = new EventEmitter<BetBuilderSelectionModel>();
    showBetbuilderInfoMessage = false;

    removeBetBuilderSelection($event: BetBuilderSelectionModel) {
        this.removeSelection.emit($event);
    }

    toggleBetbuilderInfoMessage(event: Event): void {
        event.stopPropagation();
        this.showBetbuilderInfoMessage = !this.showBetbuilderInfoMessage;
    }

    closeBetbuilderInfoMessage(): void {
        this.showBetbuilderInfoMessage = false;
    }

    get isByb(): boolean {
        return this.provider === BetBuilderProvider.BybFootball || this.provider === BetBuilderProvider.Angstrom;
    }
}
